import React, { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PVPChartsView from '../PVPChartsView/PVPChartsView';
import { POLICY_TYPE } from '../../../../constants/policy';
import { getUserCurrency } from '../../../../utils/user';

const LifePolicyStatistics = props => {
  const { intl, onChange, userDetails, PVPChartDataLife } = props;
  const [expanded, setExpanded] = useState(false);

  const currency = getUserCurrency(userDetails);
  const onChangeExpansionPanel = (event, nextExpanded) => {
    setExpanded(nextExpanded);
    if (onChange) {
      onChange(event, nextExpanded);
    }
  };

  return (
    <Accordion
      expanded={expanded}
      className="analysis-expansion analysis-expansion-overview analysis-bottom exclude-in-image"
      style={{ backgroundColor: '#3966f808' }}
      onChange={onChangeExpansionPanel}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="analysis-expansion-summary1">
        {intl.formatMessage({ id: 'Policy-Statistics' })}
      </AccordionSummary>

      <AccordionDetails className="analysis-expansion-detail">
        {/* remove chart in analysis which can be view from both A and C
							<div className="cardAnalysis analysis-expansion-element">
								<MostLongLivingPeopleChartView/>
							</div> */}
        <div className="cardAnalysis analysis-expansion-element">
          <PVPChartsView policyType={POLICY_TYPE.LIFE} data={PVPChartDataLife} currency={currency} />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    PVPChartDataLife: state.analysis.PVPChartData.life
  }),
  {}
)(LifePolicyStatistics);

export default injectIntl(container);
